import { Widgets } from '@mui/icons-material';
import { Box, Card, CardContent, Chip, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Api from '../../../Api';
import { IDispatchMaterialGroup, IMaterial, IMaterialDispatchFormControl } from '../../../interfaces';
import { Format } from '../../../utils/Format';
import { MaterialDetailsDialog } from '../../MaterialDetailsDialog';
import { GroupedMaterialRow } from './GroupedMaterialRow';
import './index.scss';

export const MaterialDispatchFormControl: React.FC<IMaterialDispatchFormControl> = ({
    requestedItem,
    valid,
    onAdjustQuantity,
    onSetQuantity,
    assigned,
    readonly,
    saving,
    ...props }: IMaterialDispatchFormControl) => {

    const qtyDisplayStyle = {
        padding: '1rem',
        color: 'white',
        textAlign: 'center',
        borderRadius: '5px'
    };

    const [storedAssembly, setStoredAssembly] = useState<IMaterial>();

    useEffect(() => {

    }, [assigned]);

    useEffect(() => {
        if (requestedItem.materialGroup.materials?.length === 1 && requestedItem.materialGroup.materials[0].storedAssemblyId)
            Api.Materials.get(requestedItem.materialGroup.materials[0].storedAssemblyId).then(response => {
                setStoredAssembly(response as IMaterial)
            });
    }, [requestedItem]);

    return (
        <Card variant="outlined" sx={{ mt: 2 }}>
            <CardContent>
                <Grid container spacing={2} flexDirection="row">
                    <Grid item xs={3}>
                        <Typography color="primary"><strong>{requestedItem.materialGroup.title}</strong></Typography>
                        <Typography>{requestedItem.materialGroup.subtitle}</Typography>
                        <Typography sx={{ mb: 2 }}>{requestedItem.materialGroup.subtitle2}</Typography>

                        {(requestedItem as IDispatchMaterialGroup)?.valueOnDispatch &&
                            <Chip
                                color="info"
                                variant="outlined"
                                label={"£" + Format.currency((requestedItem as IDispatchMaterialGroup).valueOnDispatch ?? 0 * requestedItem.requestedQuantity)}
                            />
                        }

                        {storedAssembly &&
                            <MaterialDetailsDialog
                                material={storedAssembly}
                                viewMode="stored_assembly"
                            />
                        }
                    </Grid>
                    <Grid item xs={7}>
                        <Grid item xs={12}>
                            <Table className="assign-material-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Location</TableCell>
                                        <TableCell>Rack</TableCell>
                                        <TableCell>Row</TableCell>
                                        <TableCell>Pallet Number</TableCell>
                                        <TableCell>Serial Number</TableCell>
                                        {requestedItem.materialGroup.status === 3 && < TableCell > Dispatch Ref</TableCell>}
                                        <TableCell />

                                        <TableCell>Assigned</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {requestedItem.materialGroup.materials?.map(x => (
                                        <GroupedMaterialRow
                                            key={x.materialId}
                                            material={x}
                                            {...{
                                                valid,
                                                onAdjustQuantity,
                                                onSetQuantity,
                                                assigned,
                                                readonly,
                                                ...props
                                            }}
                                        />
                                    ))}
                                </TableBody>
                            </Table>
                        </Grid>

                    </Grid>
                    <Grid item xs={1} textAlign="center" >
                        <p>Required</p>
                        <Box sx={{ backgroundColor: 'text.secondary', ...qtyDisplayStyle }} >
                            <h3>{requestedItem.requestedQuantity}</h3>
                        </Box>
                    </Grid>
                    <Grid item xs={1} textAlign="center" >
                        <p>Assigned</p>
                        <Box sx={{ backgroundColor: (valid ? 'success.main' : 'warning.main'), ...qtyDisplayStyle }} >
                            <h3>{assigned.reduce((acc, obj) => { return acc + obj.quantity }, 0)}</h3>
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card >
    );
}